<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon :content="$options.freeSet.cilHandPointDown" />
        CoreUI Icons
        <c-badge color="info">New</c-badge>
        <div class="card-header-actions">
          <a
            href="https://github.com/coreui/coreui-icons"
            rel="noreferrer noopener"
            target="_blank"
            class="card-header-action"
          >
            <small class="text-muted">Github</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-row class="text-center">
          <template v-for="(icon, iconName) in $options.freeSet">
            <c-col :key="iconName" class="mb-5" col="3" sm="2">
              <c-icon :height="42" :content="icon" />
              <div>{{ toKebabCase(iconName) }}</div>
            </c-col>
          </template>
        </c-row>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
import { freeSet } from '@coreui/icons';

export default {
  name: 'CoreUIIcons',
  freeSet,
  methods: {
    toKebabCase(str) {
      return str.replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
    },
  },
};
</script>
